export enum BloodType {
    UNKNOWN = "UNKNOWN",
    NULL_POSITIVE = "NULL_POSITIVE",
    NULL_NEGATIVE = "NULL_NEGATIVE",
    A_POSITIVE = "A_POSITIVE",
    A_NEGATIVE = "A_NEGATIVE",
    B_POSITIVE = "B_POSITIVE",
    B_NEGATIVE = "B_NEGATIVE",
    AB_POSITIVE = "AB_POSITIVE",
    AB_NEGATIVE = "AB_NEGATIVE"
}

// Mapping Enum → Label
export const bloodTypeLabels: Record<BloodType, string> = {
    [BloodType.UNKNOWN]: "-",
    [BloodType.NULL_POSITIVE]: "0+",
    [BloodType.NULL_NEGATIVE]: "0-",
    [BloodType.A_POSITIVE]: "A+",
    [BloodType.A_NEGATIVE]: "A-",
    [BloodType.B_POSITIVE]: "B+",
    [BloodType.B_NEGATIVE]: "B-",
    [BloodType.AB_POSITIVE]: "AB+",
    [BloodType.AB_NEGATIVE]: "AB-"
};


export enum Sexuality {
    MALE = "MALE",
    FEMALE = "FEMALE",
    DIVERSE = "DIVERSE"
}

export interface AccountMedData {
    accountId: number;
    birthDate: string; // ISO-Date-String instead of Java Date
    bloodType?: BloodType;
    preExistingConditions?: string;
    sex: Sexuality;
    allergies?: string;
    meds?: string;
    shareData: boolean;
}

export interface AccountMedDataUpsertDTO {
    birthDate: string;
    sex: Sexuality;
    bloodType: BloodType;
    allergies: string;
    meds: string;
    preExistingConditions: string;
    shareData: boolean;
}
